type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    clarity?: ClarityFn;
  }
}

let injected = false;

export function initClarity(): void {
  if (typeof window === 'undefined' || injected) return;
  injected = true;

  if (!window.clarity) {
    const fn: ClarityFn = (...args: unknown[]) => {
      fn.q = fn.q ?? [];
      fn.q.push(args);
    };
    window.clarity = fn;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.clarity.ms/tag/wj9pw3fbsa';
  document.head.appendChild(script);
}

export function stopClarity(): void {
  window.clarity?.('stop');
}
